import { http } from './http';

/**
 * READ (list) — adapter shaped for useListQuery
 * params: { page, size, sortBy, sortDir, q, filters:{ level, parentName } }
 * returns: { rows, total }
 */
export async function readGeoUnits(params) {
    const { filters, ...flatParams } = params || {};
    const requestParams = { ...flatParams, ...(filters || {}) };
    const { data } = await http.get('/geographic-unit', { params: requestParams });
    const raw = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);

    const rows = raw.map(x => ({
        id: x.geoUnitId,
        name: x.name,
        level: x.level,
        postCode: x.postCode,
        parentName: x.parentName,
        ...x,
    }));

    const total = Number.isFinite(data?.total) ? data.total : (data?.meta?.total ?? rows.length);

    return { rows, total };
}

/** READ (single) */
export async function getGeoUnit(id, { etag } = {}) {
    const { data, etag: nextEtag } = await http.get(`/geographic-unit/${id}`, { etag });
    const result = data && typeof data === 'object'
        ? { id: data.geoUnitId, ...data }
        : data;
    return { data: result, etag: nextEtag };
}

/** CREATE */
export const createGeoUnit = (payload) =>
    http.post('/geographic-unit', { body: payload }).then(r => r.data);

/** UPDATE (partial) */
export const updateGeoUnit = (id, patch) =>
    http.patch(`/geographic-unit/${id}`, { body: patch }).then(r => r.data);

/** REPLACE (full) — optional */
export const replaceGeoUnit = (id, body) =>
    http.put(`/geographic-unit/${id}`, { body }).then(r => r.data);

/** DELETE */
export const deleteGeoUnit = (id) =>
    http.delete(`/geographic-unit/${id}`).then(() => ({ ok: true }));

/** Taxonomies / helpers */
export const listGeoLevels = () =>
    http.get('/geographic-unit/levels').then(({ data }) => (Array.isArray(data) ? data : []));

export const listGeoParents = () =>
    http.get('/geographic-unit/parents').then(({ data }) =>
        (Array.isArray(data) ? data : []).map(({ id, name }) => ({
            value: name,
            label: name,
            id,
        }))
    );

export const listGeoParentsForEdit = () =>
    http.get('/geographic-unit/parents').then(({ data }) =>
        (Array.isArray(data) ? data : []).map(({ id, name }) => ({
            value: id,
            label: name,
        }))
    );